module.exports = __webpack_public_path__ + "static/media/UGoing-Link-Preview.d4af1b54.png";